// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowRotateClockwise_Stroke2_Corner0_Rounded as CanonicalArrowRotateClockwise_Stroke2_Corner0_Rounded} from './Arrow'
import {ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded as CanonicalArrowRotateCounterClockwise_Stroke2_Corner0_Rounded} from './Arrow'

/** @deprecated Import ArrowRotateClockwise_Stroke2_Corner0_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowRotateClockwise_Stroke2_Corner0_Rounded =
  CanonicalArrowRotateClockwise_Stroke2_Corner0_Rounded

/** @deprecated Import ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded =
  CanonicalArrowRotateCounterClockwise_Stroke2_Corner0_Rounded
